/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum LotState {
  Available = 'available',
  Unsold = 'unsold',
  Sold = 'sold',
  Withdrawn = 'withdrawn'
}
